import { useConnectivity, useT } from '../hooks';

/** Header badge; text + colour so the state is not conveyed by colour alone (WCAG 1.4.1). */
export function ConnectivityBadge() {
  const t = useT();
  const { online, browserOnline } = useConnectivity();
  const label = online ? t('operator.connectivity.online') : browserOnline ? t('operator.connectivity.apiUnreachable') : t('operator.connectivity.offline');
  return (
    <span className={`badge ${online ? 'badge--online' : 'badge--offline'}`} data-testid="connectivity">
      <span aria-hidden="true" className="badge__dot" />
      {label}
    </span>
  );
}

/** Announced once when the console goes offline (live region stays mounted). */
export function OfflineBanner() {
  const t = useT();
  const { online } = useConnectivity();
  return (
    <div role="status" aria-live="polite" className={online ? 'visually-hidden' : 'banner banner--warning'}>
      {online ? '' : t('operator.connectivity.offlineNotice')}
    </div>
  );
}
